// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1L93Bw6NjdAQaHjyK22zL_","content":"tMCOd8nw9uj2olxsLiP-L","radios":"_2-HSOkHftftom00kfnMPhk","row":"_1WFa4AjtFkyMYoLkXyXmjJ","input":"_2GSvXYQGehPhrTXX0PYWZ5","btnWrap":"_2AOcbwmkDSXsyB962QbBzr"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/MergeRequestModal/MergeRequestModal.css
// module id = 375
// module chunks = 58